import Vue from 'vue'
import Router from 'vue-router'
import storeListener from './storeListener';
import store from './store';
// import { auth } from './firebase.js';
import Login from '@/views/Login.vue'
// import Home from './views/Home.vue'

const debug = false;
const firstUnregisteredPage = '/login';
const firstRegisteredPage = '/projects';

Vue.use(Router)

/**
 * requiresAuth: page only for authenticated users
 * requiresUnauth: page only for unauthenticated users
 */
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: firstUnregisteredPage
    },
    {
      path: '/',
      redirect: firstUnregisteredPage
    },
    {
      path: firstUnregisteredPage,
      name: 'Login',
      component: Login,
      meta: {
        requiresUnauth: true,
        title: 'User login'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue'),
      meta: {
        requiresUnauth: true,
        title: 'Register new account'
      }
    },
    {
      path: '/user',
      name: 'User',
      component: () => import(/* webpackChunkName: "user" */ './views/User.vue'),
      meta: {
        requiresAuth: true,
        title: 'User details'
      }
    },
    {
      path: '/projects',
      name: 'Projects',
      component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
      meta: {
        requiresAuth: true,
        title: 'Projects list'
      }
    },
    {
      path: '/project/:id',
      name: 'Project',
      component: () => import(/* webpackChunkName: "projects" */ './views/Project.vue'),
      meta: {
        requiresAuth: true,
        title: 'Project details'
      }
    },
    {
      path: '/survey/:id',
      name: 'Survey',
      component: () => import(/* webpackChunkName: "projects" */ './views/Survey.vue'),
      meta: {
        requiresAuth: true,
        title: 'Compile survey'
      }
    },
    {
      path: '/screenshot/:project/:user/:survey',
      name: 'Screenshot',
      component: () => import(/* webpackChunkName: "screenshot" */ './views/Screenshot.vue'),
      // props: true,
      meta: {
        requiresAuth: true,
        title: 'Chart screenshot'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (debug) console.log('router.beforeEach() to:', to, 'from:', from)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresUnauth = to.matched.some(record => record.meta.requiresUnauth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  if (debug) console.log('router.beforeEach() requiresAuth:', requiresAuth, 'requiresUnauth:', requiresUnauth, 'requiresAdmin:', requiresAdmin)
  if (debug) console.log('router.beforeEach() store.state:', store.state)
  if (debug) console.log('router.beforeEach() store.state.users:', store.state.users)
  if (debug) console.log('router.beforeEach() store.state.auth:', store.state.auth)
  if (debug) console.log('router.beforeEach() store.state.auth.user:', store.state.auth.user)
  const currentUser = store.state.auth.user
  if (debug) console.log('router.beforeEach() currentUser:', currentUser)
  if (debug && currentUser) console.log('router.beforeEach() ************* ADMIN:',(store.state.auth.user.admin ? true : false));
  let urlCode = '';
  if (to.query.code) {
    urlCode = '?code=' + to.query.code;
  }
  if (requiresAdmin && (!currentUser || !currentUser.admin) ) {
    if (currentUser) next(firstRegisteredPage)
    else next(firstUnregisteredPage + urlCode)
  }
  else if (requiresAuth && !currentUser) next(firstUnregisteredPage + urlCode)
  else if (requiresUnauth && currentUser) next(firstRegisteredPage + urlCode)
  else if (requiresUnauth && !currentUser && from.query.code) {
    if (debug) console.log('router.beforeEach() **** from.query.code:', from.query.code);
    const redirectPath = to.path + '?code=' + from.query.code;
    if (to.fullPath !== redirectPath) next(redirectPath);
    else next();
  }
  else next()
})

// router.onReady(() => {
  if (debug) console.log('router.onReady() currentRoute:',router.currentRoute)
  // auth.onAuthStateChanged((user) => {
  storeListener.onAuthUserChanged((user) => {
    // setTimeout(() => {
      if (debug) console.log('router.onReady() - storeListener.onAuthUserChanged() user:',user)
      // On firebase authentication response redirect page based on user autentication
      const requiresAuth = router.currentRoute.matched.some(record => record.meta.requiresAuth)
      const requiresUnauth = router.currentRoute.matched.some(record => record.meta.requiresUnauth)
      // const requiresAdmin = router.currentRoute.matched.some(record => record.meta.requiresAdmin)
      if (debug) console.log('router.onReady() - storeListener.onAuthUserChanged() requiresAuth:',requiresAuth,'requiresUnauth:',requiresUnauth,'user:',user)
      // console.log('***************************** router:', router);
      // console.log('***************************** router.currentRoute.query:', router.currentRoute.query);
      if (user && requiresUnauth) {
        let urlCode = '';
        if (router.currentRoute.query.code) {
          if (debug) console.log('router.onReady() - storeListener.onAuthUserChanged() router.currentRoute.query.code:', router.currentRoute.query.code);
          urlCode = '?code=' + router.currentRoute.query.code;
        }
        router.replace(firstRegisteredPage + urlCode);
      }
      else if (!user && requiresAuth) {
        router.replace(firstUnregisteredPage);
      }
    // }, 500);
  })
// })

export default router